export default __webpack_public_path__ + "static/media/home-magazine-img-02.3525a7ee.jpg";